import { JButton } from '@atoms/JButton';
import { Stack, Typography } from '@mui/material';
import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';

type markAllAsReadMutationType = UseMutateFunction<
  AxiosResponse<null, any>,
  unknown,
  { userId: string | undefined },
  unknown
>;
interface MarkAsReadDialogBodyProps {
  onClose: () => void;
  title: string;
  userId: string | undefined;
  markAllAsReadMutation: markAllAsReadMutationType;
}

const MarkAsReadDialogBody = ({
  onClose,
  title,
  userId,
  markAllAsReadMutation,
}: MarkAsReadDialogBodyProps) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    markAllAsReadMutation({
      userId,
    });

    onClose();
  };
  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={8}>
          <Typography variant="caption">{title}</Typography>
        </Stack>
      </Stack>
      <Stack direction={'row'} gap={1} mt={2}>
        <JButton
          data-qa="markAsRead-button"
          variant="contained"
          color="error"
          fullWidth
          onClick={handleConfirm}
        >
          {t('SET_AS_READ')}
        </JButton>
        <JButton
          data-qa="close-button-on-markAsRead-dialog"
          onClick={onClose}
          variant="contained"
          color="info"
        >
          {t('CANCEL')}
        </JButton>
      </Stack>
    </>
  );
};

export default MarkAsReadDialogBody;
